import liveCheckReducerMap from 'wanderu-ducks-live-check';

import Explorer from '../containers/Explorer';
import reducerMap from '../ducks';

function onLoad(module, info, props, context) {
    context.store.inject({
        ...reducerMap,
        ...liveCheckReducerMap,
    });
}

export { onLoad };
export default Explorer;
